import IntegrationsService from '../../api/integrations/IntegrationsService';
import { useQuery } from '@tanstack/react-query';

export const useCheckSlackEnabled = () =>
  useQuery({
    queryKey: ['checkSlackEnabled'],
    queryFn: () => IntegrationsService.getCompanyIntegrationsStatus(),
    select: (data) => ({
      slackEnabled: !!data.slack,
    }),
  });
